import { Commit } from 'vuex';
import { SuiviFacturesAvantEcheanceState } from './state';

export enum SuiviFacturesAvantEcheance {
    GET_SUIVI_FACTURES_AVANT_ECHEANCE = 'GET_SUIVI_FACTURES_AVANT_ECHEANCE',
    GET_FACTURES_AVANT_ECHEANCE_PDF = 'GET_FACTURES_AVANT_ECHEANCE_PDF'
}

export interface SuiviFacturesAvantEcheanceActionTypes {
    commit: Commit,
    state: SuiviFacturesAvantEcheanceState,
    getters: any
}
